export function Logo({
  className = "",
  size = "md",
  inverted = false,
}: {
  className?: string;
  size?: "sm" | "md" | "lg";
  inverted?: boolean;
}) {
  const sizes = {
    sm: { wordmark: "text-xl", tag: "text-[8px] tracking-[0.32em]" },
    md: { wordmark: "text-2xl", tag: "text-[9px] tracking-[0.32em]" },
    lg: { wordmark: "text-4xl", tag: "text-[11px] tracking-[0.35em]" },
  }[size];

  const word = inverted ? "text-white" : "text-foreground";
  const tag = inverted ? "text-white/90" : "text-foreground/90";

  return (
    <div className={`flex flex-col items-center leading-none ${className}`}>
      <span className={`font-display ${sizes.wordmark} tracking-[0.18em] ${word}`}>
        AVOLUS
      </span>
      <span className={`${sizes.tag} uppercase ${tag} mt-1`}>
        Luxury Car Rental
      </span>
    </div>
  );
}
